import { render, staticRenderFns } from "./comp-visitas-resumido.vue?vue&type=template&id=cfaa2232&scoped=true"
import script from "./comp-visitas-resumido.vue?vue&type=script&lang=js"
export * from "./comp-visitas-resumido.vue?vue&type=script&lang=js"
import style0 from "./comp-visitas-resumido.vue?vue&type=style&index=0&id=cfaa2232&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfaa2232",
  null
  
)

export default component.exports